"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCompletenessByCapabilities = exports.overlayTaskCompletionState = exports.fromEntries = exports.isScLinked = void 0;
const constants_1 = require("../../../tasks/constants");
const tasks_1 = require("../../../tasks");
const types_1 = require("../../../types");
const capability_1 = require("../../../util/capability");
const isScLinked = (p) => {
    if (!p.accounts || p.accounts.length < 1)
        return false;
    return p.accounts.some((a) => a.source === 'supercontrol');
};
exports.isScLinked = isScLinked;
const fromEntries = (xs) => Object.fromEntries ? Object.fromEntries(xs) : xs.reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {});
exports.fromEntries = fromEntries;
const overlayTaskCompletionState = (state, capabilities, property) => {
    return (0, exports.fromEntries)(Object.entries(state).map(([key, value]) => {
        const overlay = tasks_1.TaskDetails[key].overlay ? tasks_1.TaskDetails[key].overlay(capabilities, property) : {};
        return [key, overlay.completion ? { completion: overlay.completion } : value];
    }));
};
exports.overlayTaskCompletionState = overlayTaskCompletionState;
const capabilitySectionMapping = {
    [constants_1.TaskSections.BEDS_BATHS_AMENITIES]: types_1.DashboardCapabilities.BedsBathsAmenities,
    [constants_1.TaskSections.ARRIVALS_HOUSE_RULES]: types_1.DashboardCapabilities.ArrivalsHouseRules,
    [constants_1.TaskSections.PRICING_FEES]: types_1.DashboardCapabilities.PricingFees,
    [constants_1.TaskSections.PHOTOS_DESCRIPTION_AVAILABILITY]: types_1.DashboardCapabilities.PhotosDescriptionAvailability,
    [constants_1.TaskSections.CHANNELS]: types_1.DashboardCapabilities.Channels,
    [constants_1.TaskSections.ACCOUNT]: types_1.DashboardCapabilities.Account
};
const filterCompletenessByCapabilities = (taskCompleteness, capabilities) => {
    const output = {};
    for (const taskKey in taskCompleteness) {
        if (taskCompleteness.hasOwnProperty(taskKey)) {
            const section = tasks_1.TaskDetails[taskKey].section;
            const enabled = (0, capability_1.hasCapability)(capabilities, capabilitySectionMapping[section]);
            if (enabled) {
                output[taskKey] = taskCompleteness[taskKey];
            }
        }
    }
    return output;
};
exports.filterCompletenessByCapabilities = filterCompletenessByCapabilities;
//# sourceMappingURL=helpers.js.map